import { FavouriteRowValue, FavouriteDataColumn } from '../../favourite/common/favourite-interfaces';
import { FavouriteDataAdapter } from '../../favourite/common/favourite-data-adapter';
import { TableFavouriteModelComponent } from '../table-favourite-model-component';
import { DataRow } from './types';
import { mapRow } from './row';

const groupRowsForCompactView = (rows: FavouriteRowValue[][], selectionDataColumns: number[]) => {

  const compareRows = (currentRow: FavouriteRowValue[], previousRow: FavouriteRowValue[]) =>
    selectionDataColumns.length === 0 ||
    selectionDataColumns.every(column => currentRow[column].value === previousRow[column].value);

  return rows
    .reduce((result, row, index) => {

      if (result.length === 0 || !compareRows(row, result[result.length - 1][0].row)) {
        result.push([{ index, row }]);
      } else {
        result[result.length - 1].push({ index, row });
      }

      return result;
    }, [] as DataRow[][]);
};

export const mapToRows = (dataAdapter: FavouriteDataAdapter,
  model: TableFavouriteModelComponent,
  rows: FavouriteRowValue[][],
  columns: FavouriteDataColumn[],
  compactView: boolean) => {

  const {
    indexesToCompare: selectionDataColumns
  } = dataAdapter;

  const groupedRows = compactView
    ? groupRowsForCompactView(rows, selectionDataColumns)
    : rows.map((row, index) => [{ row, index }]);

  return groupedRows.map(row => mapRow(dataAdapter, model, columns, compactView, row));
};
